import PropTypes from "prop-types"
import { Clock, Sun, Cloud, Moon } from "lucide-react"
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card"
import { Button } from "@/components/ui/button"
import { CalendarClock } from "lucide-react"

export const DoctorScheduleContent = ({ schedule }) => {
  if (!schedule) return null

  const days = [
    { key: "monday", label: "Mon" },
    { key: "tuesday", label: "Tue" },
    { key: "wednesday", label: "Wed" },
    { key: "thursday", label: "Thu" },
    { key: "friday", label: "Fri" },
    { key: "saturday", label: "Sat" },
    { key: "sunday", label: "Sun" },
  ]

  const timeSlots = [
    { key: "morning", label: "Morning", icon: Sun },
    { key: "afternoon", label: "Afternoon", icon: Cloud },
    { key: "evening", label: "Evening", icon: Moon },
  ]

  // Filter days with available slots
  const availableDays = days.filter(
    (day) =>
      schedule[day.key] && Object.values(schedule[day.key]).some((slot) => slot)
  )

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 pb-2 border-b">
        <Clock className="h-4 w-4 text-blue-500" />
        <h4 className="font-medium text-sm">Consultation Hours</h4>
      </div>

      <div className="space-y-3">
        {availableDays.map((day) => {
          const slots = timeSlots.filter(
            (slot) => schedule[day.key]?.[slot.key]
          )
          if (!slots.length) return null

          return (
            <div key={day.key} className="grid gap-1">
              <div className="text-sm font-medium text-gray-500">
                {day.label}
              </div>
              <div className="flex flex-wrap gap-1">
                {slots.map((slot) => {
                  const Icon = slot.icon
                  return (
                    <div
                      key={slot.key}
                      className="flex items-center gap-1 px-2 py-1 bg-blue-50 dark:bg-blue-900/20 rounded text-xs text-blue-700 dark:text-blue-300"
                    >
                      <Icon className="h-3 w-3" />
                      <span>{schedule[day.key][slot.key]}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>

      {schedule.is_oncall && (
        <div className="flex items-center justify-between pt-2 mt-2 border-t">
          <span className="text-sm text-gray-600">Emergency</span>
          <span className="text-xs px-2 py-1 bg-green-50 dark:bg-green-900/20 rounded text-green-700 dark:text-green-300">
            24/7 On Call
          </span>
        </div>
      )}
    </div>
  )
}

DoctorScheduleContent.propTypes = {
  schedule: PropTypes.object,
}

const DoctorSchedule = ({ schedule, children }) => {
  if (!schedule) return children

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Button
          variant="ghost"
          className="w-full flex items-center justify-center gap-2 text-blue-600 hover:text-blue-700 hover:bg-blue-50"
        >
          <CalendarClock className="h-4 w-4" />
          View Schedule
        </Button>
      </HoverCardTrigger>
      <HoverCardContent className="w-80" align="start">
        <DoctorScheduleContent schedule={schedule} />
      </HoverCardContent>
    </HoverCard>
  )
}

DoctorSchedule.propTypes = {
  schedule: PropTypes.object,
  children: PropTypes.node,
}

export default DoctorSchedule
